import { useEffect, useState } from "react";

export const useReadingTime = (containerClassName: string) => {
  const [readingTime, setReadingTime] = useState<number>(0);

  useEffect(() => {
    const calculateReadingTime = () => {
      // Wait for the content to be rendered
      const container = document.querySelector(`.${containerClassName}`);

      if (!container) return;

      // Get all text content, excluding script and style elements
      const text = Array.from(container.getElementsByTagName("*"))
        .map((element) => {
          // Skip if it's a script, style, or other non-content elements
          if (
            element.tagName === "SCRIPT" ||
            element.tagName === "STYLE" ||
            element.tagName === "NOSCRIPT"
          ) {
            return "";
          }

          // Get only direct text nodes of this element
          return Array.from(element.childNodes)
            .filter((node) => node.nodeType === Node.TEXT_NODE)
            .map((node) => node.textContent)
            .join(" ");
        })
        .join(" ")
        .trim();

      const wordsPerMinute = 200;
      const wordCount = text.split(/\s+/).length;
      const time = Math.ceil(wordCount / wordsPerMinute);

      setReadingTime(time);
    };

    // Initial calculation
    calculateReadingTime();

    // Recalculate if content changes
    const observer = new MutationObserver(calculateReadingTime);
    const container = document.querySelector(`.${containerClassName}`);

    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    return () => observer.disconnect();
  }, [containerClassName]);

  return readingTime;
};
